import React, { useState, useEffect } from 'react';

interface SparkleImageProps {
  src: string;
  alt: string;
  interval?: number; // en millisecondes
  opacityRange?: [number, number]; // [min, max]
}

const SparkleImage: React.FC<SparkleImageProps> = ({
  src,
  alt,
  interval = 500,
  opacityRange = [0.7, 1],
}) => {
  const [opacity, setOpacity] = useState(opacityRange[1]);

  useEffect(() => {
    const timer = setInterval(() => {
      // Génère une opacité aléatoire dans la plage spécifiée
      const newOpacity = 
        Math.random() * (opacityRange[1] - opacityRange[0]) + opacityRange[0];
      setOpacity(newOpacity);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, opacityRange]);

  return (
    <img 
      src={src} 
      alt={alt}
      className=' w-[30vw] h-[10vh] md:w-[50vw] md:h-[50vh] '
      style={{ 
        opacity: opacity,
        transition: `opacity ${interval / 1000}s ease-in-out`,
      }}
    />
  );
};

export default SparkleImage;